import {Tenant} from "@irati/types"
import getSupportedLocale, {DEFAULT_LANG} from "@irati/utils/lang/helpers/getSupportedLocale"
import getDeviceLocale from "@irati/utils/lang/helpers/getDeviceLocale"
import getTenantFromPath from "../getTenantFromPath"

export const perkboxLogo =
  "https://res.cloudinary.com/perkbox/image/upload/v1616081665/deals-light-ui/shared/Logo_-_Perkbox_Logo_Perkbox_Blue_-_2019.png"

const defaultTenant: Tenant = {
  Etag: "",
  groupId: "",
  subdomain: getTenantFromPath(),
  locale: getSupportedLocale(getDeviceLocale()) || DEFAULT_LANG,
  settings: {
    featureFlags: "",
    color: "#00adef",
    textColor: "#000",
    imageLink: perkboxLogo,
    welcomeEmail: "",
    signUpOption: "none",
    showSSOOptions: false,
    hideNormalLogin: false,
    employeeName: "",
    ssoButtonText: ""
  }
}

export default defaultTenant
